import React from 'react'
import { ElementProps } from '../base/element'
import { Item } from '../base/item'
import { defStyleChildren } from '../helpers/utils'

import { IComponent, IContainerComponent, IDefaultStyles, IStyles } from '../schemamanager/types'

export interface ICardComponent extends IContainerComponent {
  type: 'card'
  label?: string
  headerComponent?: IComponent,
  styleHeader?: IStyles
  styleLabel?: IStyles
  styleChildren?: IStyles,
}

export const Card = (props: ElementProps) => {
  const { sm, events, children } = props
  const comp = props.comp as ICardComponent

  const style: IDefaultStyles = {
    main: {
      classes: {
        margin: 'my-2',
        borderRadius: 'rounded',
        overflow: 'overflow-hidden',
        boxShadow: 'shadow-lg'
      }
    },
    styleHeader: {
      classes: {
        padding: 'px-6 py-4'
      }
    },
    styleLabel: {
      classes: {
        margin: 'mb-2',
        fontSize: 'text-xl',
        fontWeight: 'font-bold'
      }
    },
    ...defStyleChildren(),
  }

  const m = props.mergeStyles(style)


  return (
    <div {...m.main} {...events()}>
      <div {...m.styleHeader}>
        {comp.headerComponent && <Item sm={sm} comp={comp.headerComponent} />}
        {comp.label && (
          <div {...m.styleLabel}>{comp.label}</div>
        )}
      </div>
      <div {...m.styleChildren}>{children}</div>
    </div>
  )
}
